(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aftercare"] && !Shopify.designMode) return;
  try {
    
  const aftercareSections = document.querySelectorAll('.aftercare');
  aftercareSections.forEach((aftercareSection) => {
    const aftercareNavButtons = aftercareSection.querySelectorAll('[data-tab-btn]');
    const aftercareTabs = aftercareSection.querySelectorAll('[data-tab]');
    if(aftercareNavButtons) {
      aftercareNavButtons[0].classList.add('active');
      aftercareTabs[0].classList.remove('hidden');
      aftercareNavButtons.forEach((aftercareNavBtn) => {
        aftercareNavBtn.addEventListener('click', function() {
          aftercareNavButtons.forEach((btn) => {
            btn.classList.remove('active')
          });
          this.classList.add('active');
          aftercareTabs.forEach((tab) => {
            tab.classList.add('hidden')
          });
          const tabId = this.dataset.href;
          const targetTab = document.querySelector(tabId);
          if(targetTab) targetTab.classList.remove('hidden')
        })
      })
      if(location.hash && document.querySelector(location.hash)) {
        document.querySelector(`[data-href="${location.hash}"]`).dispatchEvent(new Event('click'))
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.announcementSlides = this.querySelectorAll('[data-announcement-bar]');
      this.prevButton = this.querySelector('[data-announcement-prev]');
      this.nextButton = this.querySelector('[data-announcement-next]');
      this.navButtons = this.querySelectorAll('[data-announcement-btn]');
      this.slideTime = parseInt(this.getAttribute('data-autoplay-seconds') || 0);
      this.slideOn = 1;
      this.slideInterval = false;
      this.container = this.querySelector('[data-announcement-container]');

      this.initSlider();
    }

    scrollToSlide(slides, direction, slideOn) {
      slideOn += direction;
          
      if (slideOn > slides.length) slideOn = 1;
      if (slideOn < 1) slideOn = slides.length;

      slides.forEach((slide, index) => {
        if (index == slideOn - 1)
          slides[index].classList.add('active');
        else
          slides[index].classList.remove('active');
      })
      
      return slideOn;
    }

    initSlider() {
      if(this.announcementSlides.length > 1) {
        // if auto rotation is enabled, need to setup listeners for starting/stoping slider
        if (this.slideTime > 0) {
          this.slideInterval = setInterval(() => {
            this.slideOn = this.scrollToSlide(this.announcementSlides, 1, this.slideOn);
          }, this.slideTime * 1000);

          // const stopEvents = ['focusin', 'mouseover', 'mouseenter'];
          // stopEvents.forEach((event) => {
          //   this.addEventListener(event, () => clearInterval(this.slideInterval));
          //   this.navButtons.forEach((navButton) => {
          //     navButton.addEventListener(event, () => clearInterval(this.slideInterval));
          //   });
          // });
        }
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => {
            this.slideOn = this.scrollToSlide(this.announcementSlides, -1, this.slideOn);
          });
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => {
            this.slideOn = this.scrollToSlide(this.announcementSlides, 1, this.slideOn);
          });  
        }
        
        window.addEventListener('orientationchange', () => {
          this.adjustHeight()
        }, true);
        window.addEventListener('scroll', () => {
          this.adjustHeight()
        }, true);
      }
      this.adjustHeight();
    }

    adjustHeight() {
      this.style.height = '100%';
      let max_value = 0;
      this.announcementSlides.forEach((slide) => {
        const height = slide.querySelector('.announcement-bar__link') ? slide.querySelector('.announcement-bar__link').offsetHeight : (slide.querySelector('.announcement-bar__message') ? slide.querySelector('.announcement-bar__message').offsetHeight : 0);
        if (max_value < height) max_value = height;
      });
      this.style.height = `${max_value}px`;
    }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion-new"] && !Shopify.designMode) return;
  try {
    
  var accordionItems = document.querySelectorAll('.faq-accordion-items li');

  for(var i = 0; i < accordionItems.length; i++) {
    accordionItems[i].addEventListener('click', function(e) {
      if (!this.classList.contains('active')) {
        let index = 1;
        const ul = this.closest('ul.faq-accordion-list');
        const childs = ul.querySelectorAll('li.faq-accordion-item');
        while( this != ul.querySelector('li.faq-accordion-item:nth-child(' + index + ')') )  {
          index++;
        }
        for(var j = 0; j < childs.length; j++) {
          childs[j].classList.remove('active')
        }
        this.classList.add('active');
      } else {
        this.classList.remove('active');
      }
    });
  }

  var accordionTexts = document.querySelectorAll('.faq-accordion-items .item__description');
  accordionTexts.forEach((accordionText) => {
    accordionText.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion-v2"] && !Shopify.designMode) return;
  try {
    
  function setAccordionState(li, expanded) {
    var btn = li.querySelector('.item__title');
    var panel = li.querySelector('.item__description');
    if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (panel) panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  }

  var accordionItems = document.querySelectorAll('.faq-accordion-items li.faq-accordion-item');
  for (var i = 0; i < accordionItems.length; i++) {
    accordionItems[i].addEventListener('click', function(e) {
      if (e.target.closest('.item__description')) return;
      if (!this.classList.contains('active')) {
        var ul = this.closest('ul.faq-accordion-list');
        var childs = ul.querySelectorAll('li.faq-accordion-item');
        for (var j = 0; j < childs.length; j++) {
          childs[j].classList.remove('active');
          setAccordionState(childs[j], false);
        }
        this.classList.add('active');
        setAccordionState(this, true);
      } else {
        this.classList.remove('active');
        setAccordionState(this, false);
      }
    });
  }

  var accordionTexts = document.querySelectorAll('.faq-accordion-items .item__description');
  accordionTexts.forEach((accordionText) => {
    accordionText.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  var accordionItems = document.querySelectorAll('.faq-accordion-items li');

  for(var i = 0; i < accordionItems.length; i++) {
    accordionItems[i].addEventListener('click', function(e) {
      if (!this.classList.contains('active')) {
        let index = 1;
        const ul = this.closest('ul.faq-accordion-list');
        const childs = ul.querySelectorAll('li');
        const images = this.closest('.faq-accordion-main').querySelectorAll('.faq-accordion-images picture');
        while( this != ul.querySelector('li:nth-child(' + index + ')') )  {
          index++;
        }
        for(var j = 0; j < childs.length; j++) {
          childs[j].classList.remove('active')
        }
        for(var j = 0; j < images.length; j++) {
          images[j].classList.add('hide')
        }
        this.classList.add('active');
        
        if(images[index-1]) {
          images[index-1].classList.remove('hide')
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('#section-{{ section.id }} .faq-item');
    
    faqItems.forEach(function(item) {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      const toggle = item.querySelector('.faq-toggle');
      
      question.addEventListener('click', function() {
        const isActive = item.classList.contains('active');
        
        // Close all other items
        faqItems.forEach(function(otherItem) {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
            otherItem.querySelector('.faq-toggle').textContent = '+';
          }
        });
        
        // Toggle current item
        if (isActive) {
          item.classList.remove('active');
          toggle.textContent = '+';
        } else {
          item.classList.add('active');
          toggle.textContent = '-';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fifty-fifty"] && !Shopify.designMode) return;
  try {
    
  var fiftyFiftyCTAs = document.querySelectorAll('.fifty-fifty__item--cta[data-inited="false"]');
  if(fiftyFiftyCTAs.length > 0) {
    for(var i = 0; i < fiftyFiftyCTAs.length; i++) {
      fiftyFiftyCTAs[i].addEventListener("mouseenter", function() {
        this.closest('.fifty-fifty__item').querySelector('img').classList.add('media--zoom__hovered')
      });
      fiftyFiftyCTAs[i].addEventListener("mouseleave", function() {
        this.closest('.fifty-fifty__item').querySelector('img').classList.remove('media--zoom__hovered')
      });
      fiftyFiftyCTAs[i].setAttribute('data-inited', true);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }
    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      if(this.querySelector('form')) this.querySelector('form').submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.accountIcon = document.querySelector('[data-account-icon]');
      this.accountNavList = document.querySelector('[data-account-nav]');
      this.accountActive = false;
      this.parents = document.querySelectorAll(`[data-parent-item]`);
      this.containers = document.querySelectorAll('header .details');

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.accountNav();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }
    accountNav() {
      if(this.accountIcon) {
        this.accountIcon.addEventListener('mouseenter', (e) => {
          this.accountIcon.classList.add('active');
          this.accountActive = true;
        });
        this.accountIcon.addEventListener('mouseleave', (e) => {
          this.accountActive = false;
          setTimeout(() => {
            if(this.accountActive == false) this.accountIcon.classList.remove('active');
          }, 500);
        });
      }
      if(this.accountNavList) {
        this.accountNavList.addEventListener('mouseenter', (e) => {
          this.accountIcon.classList.add('active');
          this.accountActive = true;
        });
        this.accountNavList.addEventListener('mouseleave', (e) => {
          this.accountActive = false;
          setTimeout(() => {
            if(this.accountActive == false) this.accountIcon.classList.remove('active');
          }, 500);
        });
      }
      this.parents.forEach(parent => {
        parent.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.keyCode === 13 || e.key === 'ArrowDown') {
            e.preventDefault();
            const details = parent.closest('.details');
            this.containers.forEach(container => container.removeAttribute('open'));
            details?.setAttribute('open', 'true');
            setTimeout(() => {
              details?.querySelector('.header__submenu')?.querySelector('a, button')?.focus();
            }, 300)
          }
        })
      });
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-custom-block"] && !Shopify.designMode) return;
  try {
    
  if (!isMobile()) {
    var texts = document.querySelectorAll('.image-and-hover .hover_text')
    if(texts) {
      for (var i = 0; i < document.querySelectorAll('.image-and-hover .hover_text').length; i++) {
        var text = document.querySelectorAll('.image-and-hover .hover_text')[i];
        text.classList.remove('hide');
        text.addEventListener("mousemove", function(e){
          this.closest('.image-and-hover').querySelector('.hover_cursor').style.left = (e.offsetX - 15) + 'px';
          this.closest('.image-and-hover').querySelector('.hover_cursor').style.top = (e.offsetY - 15) + 'px';
        });
      }  
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-shop-by"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('shop-by')) {
    customElements.define(
      'shop-by',
      class ShopBy extends HTMLElement {
        constructor() {
          super()
          const swiperWrapper = this.querySelector(`[data-media-swiper]`)

          window.addEventListener('resize', () => {
				    this.setupSwiper(swiperWrapper)
				  })
				  this.setupSwiper(swiperWrapper)
        }

        setupSwiper(swiperWrapper) {
        	if(!swiperWrapper.classList.contains('swiper-initialized') && window.innerWidth < 750) {
			      new Swiper(swiperWrapper, {
			        slidesPerView: 1.4,
			        slidesPerGroup: 1,
			        spaceBetween: 17,
			        loop: true,
			        navigation: {
			          nextEl: '.swiper-button-next',
			          prevEl: '.swiper-button-prev',
			        },
			        breakpoints: {
			          320: {
			            slidesPerView: 1.4,
			            slidesPerGroup: 1,
			          },
			          640: {
			            slidesPerView: 2,
			            slidesPerGroup: 2,
			          }
			        }
			      });
				  } else if(swiperWrapper.classList.contains('swiper-initialized') && window.innerWidth >= 750) {
				    swiperWrapper.swiper.destroy(true, true);
				  }
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-social-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-social')) {
    customElements.define(
      'home-social',
      class HomeSocial extends HTMLElement {
        constructor() {
          super();

          this.titleSwiper = new Swiper(this.querySelector('[data-title-swiper]'), {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            mousewheel: {
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true,
              thresholdDelta: 30,
            },
            direction: "horizontal",
            loop: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            autoplay: {
              delay: 5000,
            },
          });
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-social"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-social')) {
    customElements.define(
      'home-social',
      class HomeSocial extends HTMLElement {
        constructor() {
          super();

          this.titleSwiper = new Swiper(this.querySelector('[data-title-swiper]'), {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            mousewheel: {
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true,
              thresholdDelta: 30,
            },
            direction: "horizontal",
            loop: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            autoplay: {
              delay: 5000,
            },
          });
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-v2')) {
    customElements.define(
      'testimonials-v2',
      class TestimonialsV2 extends HTMLElement {
        constructor() {
          super()
          
          this.swiper = new Swiper(this.querySelector('[data-media-swiper]'), {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 27,
            autoplay: {
              delay: 5000,
            },
            breakpoints: {
              300: {
                slidesPerView: 1,
                spaceBetween: 0,
                slidesPerGroup: 1,
              },
              901: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
            },
            navigation: false
          })
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
	class HomeTestimonials extends HTMLElement {
    constructor() {
      super();
      this.swiperWrapper = this.querySelector('[data-media-swiper]');
      this.slides = this.swiperWrapper.querySelectorAll('.swiper-slide');
      this.swiper = null;
      this.initSwiper();
    }

    initSwiper() {
      this.swiper = new Swiper(this.swiperWrapper, {
      	slidesPerView: 1,
      	effect: 'fade',
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				navigation: {
			    nextEl: '.swiper-button-next',
			    prevEl: '.swiper-button-prev',
			  },
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				autoplay: {
			    delay: 8000,
					disableOnInteraction: true,
			  },
				watchSlidesProgress: true,
				on: {
					slideChange: (swiper) => {
						const bullets = this.swiperWrapper.querySelectorAll('.swiper-pagination-bullet');
						bullets.forEach((bullet, index) => {
							if(index < swiper.activeIndex)
								bullet.classList.add('swiper-pagination-bullet-viewed');
							else
								bullet.classList.remove('swiper-pagination-bullet-viewed');
						});
					}
				},
			});
    }
  }

  customElements.define('home-testimonials', HomeTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelector('.sparkle-1')) {
    function animateElement(element)  {
      let y = -window.pageYOffset * 0.5;
      element.style.transform = 'translate3d(0, ' + y + 'px,0)';
    }
    window.onscroll = function() {
      animateElement(document.querySelector('.sparkle-1'));
      animateElement(document.querySelector('.sparkle-2'));
      animateElement(document.querySelector('.sparkle-3'));
    };
    const triggerEvent = new Event('scroll');
    window.dispatchEvent(triggerEvent);
    window.onresize = function() {
      const triggerEvent = new Event('scroll');
      window.dispatchEvent(triggerEvent);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-by-category"] && !Shopify.designMode) return;
  try {
    
  class LookbookByCategory extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[data-target]');
      this.panels = this.querySelectorAll('[data-lookbook-by-category-content]');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          const id = e.target.dataset.target;
          this.tabs.forEach((t) => {
            if (t == e.target)
              t.closest('li').classList.add('lookbook-by-category--nav__active');
            else
              t.closest('li').classList.remove('lookbook-by-category--nav__active');
          });
          this.panels.forEach((panel) => {
            if (id == panel.id)
              panel.classList.remove('hidden');
            else
              panel.classList.add('hidden');
          });
        });
      });
    }
  }
  customElements.define('lookbook-by-category', LookbookByCategory);

  class LookbookByCategoryContent extends HTMLElement {
    constructor() {
      super();
      this.seaAllBtn = this.querySelector('[data-show-all]');
      this.items = this.querySelectorAll('[data-lookbook-content]');
      if (this.seaAllBtn) {
        this.seaAllBtn.addEventListener('click', (e) => {
          if (e.target.innerHTML == 'See All')
            e.target.innerHTML = 'See Less';
          else
            e.target.innerHTML = 'See All';
          this.items.forEach((item, index) => {
            if (index >= 9) {
              if (e.target.innerHTML == 'See All')
                item.classList.add('hidden');
              else
                item.classList.remove('hidden');
            }
          })
        })
      }
    }
  }
  customElements.define('lookbook-by-category-content', LookbookByCategoryContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if(location.pathname == '/collections/all') location.href = '/collections/hypoallergenic-jewelry';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piercing-banner"] && !Shopify.designMode) return;
  try {
    
  const piercingBannerNavs = document.querySelectorAll('[data-section-type="piercing-banner"] a');
  piercingBannerNavs.forEach((childNav) => {
    childNav.addEventListener('click', (e) => {
      const href = e.target.href;
      
      if (href.includes('#') && href.split('#')[1]) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(`#${href.split('#')[1]}`).offset().top - 150
        }, 700);
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piercing-cards"] && !Shopify.designMode) return;
  try {
    
  const studioNavOpen = document.querySelector('[data-studio-nav-open]');
  studioNavOpen.addEventListener('click', function() {
    if(this.classList.contains('active'))
      this.classList.remove('active');
    else
      this.classList.add('active');
  });

  const stateFilterBtns = document.querySelectorAll('.studios-nav--list [data-state]');
  const studioLists = document.querySelectorAll('.piercing-cards__category');
  const mainStudioList = document.querySelector('[data-main-studio-list]');
  const studioSelected = document.querySelector('[data-studio-selected]');
  const mainCards = mainStudioList.querySelectorAll('[data-state]');

  stateFilterBtns.forEach((stateFilterBtn) => {
    stateFilterBtn.addEventListener('click', function() {
      stateFilterBtns.forEach((btn) => {
        if(this != btn) btn.classList.remove('active');
      });
      this.classList.add('active');

      const selectedState = this.dataset.state;

      studioLists.forEach((studioList) => {
        const state = studioList.dataset.state;
        if(selectedState != state) {
          studioList.classList.remove('active');
          studioList.closest('.piercing-cards__list--wrapper').classList.remove('active');
          if(selectedState == 'all-locations') {
            studioList.closest('.piercing-cards__list--wrapper').classList.remove('hidden');
          } else {
            studioList.closest('.piercing-cards__list--wrapper').classList.add('hidden');
          }
        } else {
          studioList.classList.add('active');
          studioList.closest('.piercing-cards__list--wrapper').classList.add('active');
          studioList.closest('.piercing-cards__list--wrapper').classList.remove('hidden');
          mainStudioList.classList.add('active');
        }
      });
      if(selectedState == 'all-locations') {
        mainStudioList.classList.remove('active');
        mainStudioList.closest('.piercing-cards__list--wrapper').classList.remove('active');
        studioSelected.classList.remove('active');
      } else {
        mainStudioList.closest('.piercing-cards__list--wrapper').classList.add('active');
        studioSelected.querySelector('[data-text]').innerHTML = selectedState.replace('-', ' ');
        studioSelected.classList.add('active');
      }
      studioNavOpen.classList.remove('active');

      mainCards.forEach((card) => {
        const cardState = card.dataset.state;
        if (selectedState == 'all-locations')
          card.classList.remove('hide');
        else {
          if (cardState == selectedState)
            card.classList.add('hide');
          else
            card.classList.remove('hide');
        }
      });
    });
  });
  studioSelected.addEventListener('click', function() {
    const allBtn = document.querySelector('.studios-nav--list [data-state="all-locations"]');
    const clickEvent = new Event('click');
    allBtn.dispatchEvent(clickEvent);
  });

  function checkHash() {
    if(location.hash != '' && location.hash != null) {
      const hash = location.hash.replace('#', '');
      const hashStudio = document.querySelector(`.studios-nav [data-state="${hash}"]`);
      if(hashStudio) {
        const clickEvent = new Event('click');
        hashStudio.dispatchEvent(clickEvent);  
      }
    }
  }
  checkHash();

  window.addEventListener('popstate', () => {
    checkHash();    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piercing-experience"] && !Shopify.designMode) return;
  try {
    
  const experienceItems = document.querySelectorAll('.piercing-experience .experience-item');
  for(var i=0; i < experienceItems.length; i++) {
    experienceItems[i].addEventListener('click', function(e) {
      const currentExperienceItems = this.closest('.piercing-experience').querySelectorAll('.experience-item');
      const currentTextItems = this.closest('.piercing-experience').querySelectorAll('.text');
      let itemIndex = null;
      for(var j=0; j < currentExperienceItems.length; j++) {
        currentExperienceItems[j].classList.remove('active');
        if(currentExperienceItems[j] == this) itemIndex = j;
      }
      for(var j=0; j < currentTextItems.length; j++) {
        currentTextItems[j].classList.remove('active')
      }
      if(currentTextItems[itemIndex]) currentTextItems[itemIndex].classList.add('active');
      this.classList.add('active');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piercing-studio"] && !Shopify.designMode) return;
  try {
    
  const studioServices = document.querySelectorAll('.piercing-studio .cost-services');
  const studioOverlays = document.querySelectorAll('.piercing-studio .overlay');
  for(var i = 0; i < studioServices.length; i ++) {
    studioServices[i].addEventListener('mouseenter', function(e) {
      this.classList.add('active')
    });
  }
  for(var i = 0; i < studioOverlays.length; i ++) {
    studioOverlays[i].addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.previousElementSibling.classList.remove('active')
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-text"] && !Shopify.designMode) return;
  try {
    
  const seoReadMore = document.querySelector('.seo-text-item .read_more');
  if(seoReadMore) {
    seoReadMore.addEventListener("click", function() {
      const content = this.closest('.seo-text-item-content');
      const hiddenArea = content.querySelector('.hidden_area');
      if(content.classList.contains('collapsed')) { 
        content.classList.remove('collapsed');
        hiddenArea.setAttribute('aria-hidden', 'true');
        hiddenArea.classList.add('hidden');
        hiddenArea.removeAttribute('tabindex');
      } else {
        hiddenArea.classList.remove('hidden');
        hiddenArea.setAttribute('aria-hidden', 'false');
        hiddenArea.removeAttribute('tabindex');
        content.classList.add('collapsed');
      }
      if (content.classList.contains('collapsed'))
        hiddenArea.style.height = hiddenArea.scrollHeight + 'px';
      else
        hiddenArea.style.height = '0px';
    });
    window.addEventListener('resize', function () {
      const content = document.querySelector('.seo-text-item-content');
      const hiddenArea = document.querySelector('.hidden_area');
      if (content.classList.contains('collapsed')) {
        hiddenArea.style.height = '0px';
        setTimeout(function() {
          hiddenArea.style.height = hiddenArea.scrollHeight + 'px';
        }, 300);
      } else
        hiddenArea.style.height = '0px';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-v2"] && !Shopify.designMode) return;
  try {
    
  const shopByV2Swipers = document.querySelectorAll('[data-shop-by-v2-swiper]');
  shopByV2Swipers.forEach((swiperContainer) => {
    var v2Swiper = null;
    function initSwiper() {
      if(window.innerWidth >= 990) {
        v2Swiper = new Swiper(swiperContainer, {
          speed: 400,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            320: {
              slidesPerView: 2,
            },
            600: {
              slidesPerView: 3,
            },
            990: {
              slidesPerView: 4,
            }
          },
        });
      } else {
        if(v2Swiper) v2Swiper.destroy(true, true);
      }
    }
    initSwiper();
    window.addEventListener('resize', () => initSwiper());
  });

  } catch(e) { console.error(e); }
})();
})();
